module.exports = __webpack_public_path__ + "static/media/up.eeae85b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/up.svg
// module id = 490
// module chunks = 0